// User-avatar wrapper over the shared stable-asset helpers (see
// utils/stableAssetSrc.ts for why versioning is needed): narrows `size` to the
// variants the avatar pipeline actually generates.

type UserAvatarSize = 128 | 256 | 512

export function userAvatarSrc(
  avatarUrl: string | null | undefined,
  size: UserAvatarSize,
): string | undefined {
  return stableAssetSrc(avatarUrl, size)
}

// Called after a successful avatar upload (useUpdateUserAvatarMutation).
// 512 exists in storage but no render site uses it — add it here if one does.
export function bumpUserAvatarVersion(avatarUrl: string) {
  bumpStableAssetVersion(avatarUrl, [128, 256])
}
